
import React, { useState, useEffect, useReducer, createContext, Suspense } from "react";
import { AuthProvider } from "./context/AuthProvider";
import RequireAuth from "./components/RequireAuth";
import { ToastContainer, toast } from "react-toastify";
import { AnimatePresence } from "framer-motion";

import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

import PersistLogin from "./components/PersistLogin";

import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

import "react-toastify/dist/ReactToastify.css";
import "./styles/global.scss";
import "./styles/Dameron.ttf";

import 'bootstrap/dist/css/bootstrap.min.css';

import TestRoute from "./components/TestRoute";
import FrontPage from "./components/FrontPage";
import Login from "./components/Login";
import UserDashboard from "./components/UserDashboard";
import CollectorTest from "./components/CollectorTest";

function App() {

  const navigate = useNavigate();
  const location = useLocation();
  const helmetContext = {};
  return (
    <HelmetProvider context={helmetContext}>
      <AuthProvider>
        <Suspense
          fallback={
            <Box 
              sx={{ 
                display: 'flex',
                height: "calc(100vh - 50px)",
                width: '100%',
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "50px",
                color: "#fff",
                fontSize: "2rem",
                fontFamily: "Lato, sans-serif"
              }}
            >
              <LinearProgress className="lazy-loader-bar" sx={{ width: "100%", position: "absolute", top: "50px"}}/>
              <div>Fetching content ...</div>
            </Box>
          }
        >

          <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
                <Route 
                  path="/" 
                  element={
                    <FrontPage />
                  } 
                />
                <Route 
                  path="/users" 
                  element={
                    <UserDashboard />
                  } 
                />
              
                {/* <Route 
                  path="/login" 
                  element={
                    <Login socket={null} />
                  } 
                /> */}
                <Route element={<PersistLogin />}>
                  <Route 
                    path="/test-route" 
                    element={
                      <RequireAuth>
                        <TestRoute />
                      </RequireAuth>
                    } 
                  />
                </Route>
          
                <Route path="*" element={<p>Not found</p>} />
                
              </Routes>
          </AnimatePresence>

        </Suspense>
        <ToastContainer 
            position="bottom-right"
            draggable
            theme="dark"
            autoClose={2000}
        />
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
